import React, { useState } from 'react';
import styled from 'styled-components';
import { ProductTable } from '../components/table/product_table';
import { Product } from '../domain/product/product';

const Root = styled.div`
  background: #fff;
  padding: 1rem;
`;

const Header = styled.header`
  display: block;
  font-weight: bold;
  letter-spacing: 0.02rem;
  margin-bottom: 1rem;
`;

const Body = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const ClientAdminProductsView = () => {
  const [product, setProduct] = useState<Product| null>(null);

  return (
    <Root>
      <div id="popup" />
      <Header>Products</Header>

      <Body>
        <div>
          <ProductTable onSelected={(p: Product) => setProduct(p)} />
        </div>
      </Body>
    </Root>
  );
};
